import React, { useEffect, useState } from 'react'
import { useParams, useHistory, withRouter } from 'react-router-dom'
import { Form } from 'react-bootstrap'
import { routes } from '../../../../constantes/routes'
import { useDispatch, useSelector } from 'react-redux'
import { swalTitle } from '../../../../constantes/swalTitle'
import { swalAlertError, swalSuccessGeneral } from '../../../../utils/swalAlert'
import AddHospitalToContactForm from '../add-hospitalToContact/AddHospitalToContactForm'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import '../../../../assests/styles/contatcs/deleteInputFormBtn.scss'
import Header from '../../../header/Header'
import { hospitalsContactsActions } from '../../../../actions/hospitalsContactsActions'
import validators from '../../../../utils/validationsRegEx'

const EditContactHospitalDetails = () => {
  const { id } = useParams() //Este es el id_ContactoHospital
  const history = useHistory()
  const dispatch = useDispatch()

  const departaments = useSelector((state) => state.departaments)
  const positions = useSelector((state) => state.positions)
  const specialties = useSelector((state) => state.specialties)
  // const hospitals = useSelector(state => state.hospitals)
  const timeSlots = useSelector((state) => state.timeSlots)
  const hospitalContacts = useSelector((state) => state.hospitalsContacts)

  const updateHospitalContactDetails = (contact) =>
    dispatch(hospitalsContactsActions.updateHospitalContactDetails(contact))

  const [isDisable, setIsDisable] = useState(false)
  const [inputs, setinputs] = useState({
    id_ContactoHospital: id,
    id_Contacto: '',
    id_TipoDepartamento: '',
    id_TipoEspecialidad: '',
    id_TipoCargo: '',
    id_Hospital: '',
    id_TipoFranjaHoraria: '',
  })

  // const dispatch = useDispatch()
  // const getAllHospitals = () => dispatch(hospitalsActions.getAllHospitals(0))

  useEffect(() => {
    getContactHospitalInfoById(id)
    // getAllHospitals()
  }, [id])

  const getContactHospitalInfoById = async (idContactHospital) => {
    try {
      const contact = hospitalContacts.find((x) =>
        x.hospitalsContacts.find(
          (x) => x.id_ContactoHospital.toString() === id,
        ),
      )
      const hospitalContact = contact.hospitalsContacts.find(
        (x) => x.id_ContactoHospital.toString() === id,
      )

      Object.keys(inputs).map((input) =>
        setinputs((inputs) => ({ ...inputs, [input]: hospitalContact[input] })),
      )
      setinputs((i) => ({ ...i, id_Contacto: contact.id_Contacto }))
    } catch (error) {
      toContacts()
    }
  }

  const handleSubmitToUpdateContactHospital = async (event) => {
    event.preventDefault()
    setIsDisable(true)
    try {
      await updateHospitalContactDetails(inputs)
      swalSuccessGeneral(swalTitle.Actualizado)
      history.push(routes.CONTACTS)
    } catch (error) {
      swalAlertError(
        error.response || error.response.statusText,
        'No se ha podido actualizar los cambios, asegurate de rellenar todos los campos obligatorios',
      )
      setIsDisable(false)
    }
  }

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const handleChangeSelect = (event, idSelected) => {
    const value = event.value
    setinputs((inputs) => ({ ...inputs, [idSelected]: value }))
  }

  const validateForm = () => {
    return (
      validators.hasValue(inputs?.id_TipoDepartamento) &&
      validators.hasValue(inputs?.id_TipoEspecialidad) &&
      validators.hasValue(inputs?.id_Hospital) &&
      validators.hasValue(inputs?.id_TipoCargo)
    )
  }

  const toContacts = () => {
    history.push(routes.CONTACTS)
  }

  return (
    <div className='products'>
      <Header
        text={'Editar hospital del contacto'}
        route={() => history.goBack()}
        backBtn={false}
      />
      <div className='task__container'>
        <Form>
          <div className='row col-12 form__container'>
            <AddHospitalToContactForm
              inputs={inputs}
              departaments={departaments}
              positions={positions}
              specialties={specialties}
              // hospitals={hospitals}
              timeSlots={timeSlots}
              handleChange={handleChange}
              handleChangeSelect={handleChangeSelect}
              isDisable={isDisable || !validateForm()}
            />
            <button
              onClick={handleSubmitToUpdateContactHospital}
              disabled={isDisable}
              className='btn save'
            >
              {onSubmitText.Guardar}
            </button>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default withRouter(EditContactHospitalDetails)
